import React from 'react';
import { getMonthNameById } from '../services/MyCollections';

const MyPDFContent = ({ clients, data }) => {
    const currentDate = new Date().toLocaleDateString();

    return (
        <div id="pdfContent" style={{
            fontFamily: 'Arial, sans-serif',
            margin: '20px',
            color: '#333',
            lineHeight: '1.5'
        }}>
            {/* Lewy górny róg */}
            <div style={{
                position: 'absolute',
                top: '10px',
                left: '20px',
                fontSize: '14px',
                lineHeight: '1.2',
                fontWeight: 'bold'
            }}>
                <div>{data.accountantName}</div>
                <div>{data.accountantCompanyName}</div>
            </div>

            {/* Prawy górny róg */}
            <div style={{
                position: 'absolute',
                top: '10px',
                right: '20px',
                fontSize: '14px',
                fontWeight: 'bold'
            }}>
                {currentDate}
            </div>
            <br />
            <br />
            <br />
            <h3 style={{
                textAlign: 'center',
                color: '#2c3e50',
                borderBottom: '2px solid #2980b9',
                paddingBottom: '10px'
            }}>Oświadczenie</h3>
            <br />
            <p style={{
                fontSize: '14px',
                textAlign: 'justify',
                marginBottom: '20px'
            }}>
                Oświadczam, że w oparciu o otrzymane dowody księgowe rozliczane za m-c {getMonthNameById(data.month.toString())} {data.year}, prowadziłam/em rzetelnie i zgodnie z obowiązującymi przepisami prawa księgi rachunkowe powierzonych mi podmiotów:
            </p>
            {/* Lista numerowana */}
            <ol style={{ fontSize: '14px', marginLeft: '20px', marginBottom: '20px' }}>
                {clients.map((client, index) => (
                    <li key={index}>
                        {client}
                        {index < clients.length - 1 && ','}
                    </li>
                ))}
            </ol>
            <br></br>
            <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '20px',
                // pageBreakInside: 'avoid'
            }}>
                <thead style={{
                    backgroundColor: '#2980b9',
                    color: 'white'
                }}>
                    <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <th style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'left'
                        }}>Deklaruję, że we wszystkich wymaganych prawem przypadkach:</th>
                        <th style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'left'
                        }}>Tak</th>
                        <th style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'left'
                        }}>Nie</th>
                    </tr>
                </thead>
                <tbody>
                <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            pageBreakInside: 'avoid'
                        }}>Deklaracje VAT-7 (7K, 9M, UE, inne) zostały sporządzone i wysłane w terminie (UPO)</td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="vat7" checked />
                        </td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="vat7" />
                        </td>
                    </tr>
                    <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            pageBreakInside: 'avoid'
                        }}>Zaliczki CIT-8 (CIT-8K, CIT-8E, inne) zostały naliczone</td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="cit8" checked />
                        </td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="cit8" />
                        </td>
                    </tr>
                    <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            pageBreakInside: 'avoid'
                        }}>Zaliczki PIT-4 zostały naliczone</td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="pit4" checked />
                        </td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="pit4" />
                        </td>
                    </tr>
                    <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            pageBreakInside: 'avoid'
                        }}>Wynagrodzenia zostały naliczone</td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="wynagrodzenia" checked />
                        </td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="wynagrodzenia" />
                        </td>
                    </tr>
                    <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            pageBreakInside: 'avoid'
                        }}>Deklaracje DRA ZUS zostały sporządzone i wysłane w terminie</td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="draZUS" checked />
                        </td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="draZUS" />
                        </td>
                    </tr>
                    <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            pageBreakInside: 'avoid'
                        }}>Dokumenty księgowe zostały wprowadzone i zadekretowane (dokumenty sprzedaży, dokumenty kosztowe, wyciągi bankowe, wynagrodzenia, amortyzacja)</td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="dokumentyKsiegi" checked />
                        </td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="dokumentyKsiegi" />
                        </td>
                    </tr>
                    <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            pageBreakInside: 'avoid'
                        }}>Informacje o rozliczeniach podatkowych i ZUS zostały przekazane klientom w terminie</td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="informacje" checked />
                        </td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="informacje" />
                        </td>
                    </tr>
                    <tr style={{
                        pageBreakInside: 'avoid'
                    }}>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            pageBreakInside: 'avoid'
                        }}>Wszystkie dokumenty udostępnione przez klientów znajdują się na dedykowanym dysku, w katalogu rozliczanego okresu</td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="dysk" checked />
                        </td>
                        <td style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            textAlign: 'center',
                            pageBreakInside: 'avoid'
                        }}>
                            <input type="radio" name="dysk" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default MyPDFContent;